var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"byDate",staticStyle:{"min-height":"700px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }